import { Grid, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import FilledButton from "./FilledButton";

const AboutSection = () => {
  return (
    <>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        gap={{ base: "10", md: "10", lg: "20" }}
        p={{ base: "5", md: "10", lg: "20" }}
        alignItems="center"
      >
        <Image
          src="../assets/about.jpg"
          borderRadius="4xl"
          height={{ base: "500px", md: "600px" }}
          w="full"
        />
        <Stack gap={5} w={{ base: "xs", md: "sm", lg: "lg" }}>
          <Text
            fontSize={{ base: "xl", md: "3xl", lg: "4xl" }}
            fontWeight="semibold"
          >
            Helping You Get Things Done, Anytime, Anywhere
          </Text>
          <Text color="black">
            At Glory Online Cyber Cafe, we make everyday tasks easy and
            accessible for everyone. From government form submissions to custom
            graphic design, our goal is to provide quick and reliable services
            to help you accomplish more in less time. With our 24/7 availability
            and range of services, we're here to support your needs, day or
            night. <br /> <br />
            Our team is dedicated to offering hassle-free solutions, whether you
            need a new ID, a passport photo, or a professional document typed
            and formatted. We're more than just a service provider – we're your
            trusted partner for all your documentation and digital needs.
            <br /> <br />
            Discover the convenience of our services, available anytime, right
            at your fingertips.
          </Text>

          <FilledButton title="LEARN MORE" url="/about" px="10" />
        </Stack>
      </Grid>
    </>
  );
};

export default AboutSection;
